import { render, staticRenderFns } from "./CoverageDtc.vue?vue&type=template&id=240c2834&"
import script from "./CoverageDtc.vue?vue&type=script&lang=js&"
export * from "./CoverageDtc.vue?vue&type=script&lang=js&"
import style0 from "./CoverageDtc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports